import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../colorVars';
import { useAlertsStore } from '../../../../../../../../stores/websocketStore/_alertsStore';
import { Body2 } from '../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../alertFormClass';
import style from './WatchlistSelect.module.css';

export const WatchlistSelect = observer(() => {
  const form = useAlertFormStore();
  const alertStore = useAlertsStore();
  const watchlists = alertStore.listOfWatchlistNames;

  return (
    <div className={style.container}>
      <Body2 color={colors.lightGrey} fontWeight={700}>
        Watchlist
      </Body2>
      <select
        className={style.select}
        value={form.watchlistName}
        onChange={({ target }) => form.setWatchlistName(target.value)}
      >
        <option value="default">Select a watchlist...</option>
        {watchlists.map((watchlist) => (
          <option key={watchlist} value={watchlist}>
            {watchlist}
          </option>
        ))}
      </select>
    </div>
  );
});
